import { RegisterItem } from "routes/asset-register/register-item"
import { RegimesForRegister } from "routes/asset-register/plugins/regimes-for-register/regimes-for-register"

RegisterItem.plug(<RegimesForRegister $lazy />)
